import React from 'react';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';
import LinkBlocked from './pages/LinkBlocked';
import Pricing from './pages/Pricing';
import KitchenSink from './kitchensink';
import AppsDirectory from './pages/AppsDirectory';
import Solutions from './pages/Solutions';

const App = () => {
  return (
    <Switch>
      <Route path="/link-blocked/" component={LinkBlocked} />
      <Route path="/pricing*" component={Pricing} />
      <Route path="/kitchensink/contentweb/*" component={KitchenSink} />
      <Route path="/apps*" component={AppsDirectory} />
      <Route path="/market-research/solutions/" component={Solutions} />
    </Switch>
  );
};

export default App;
